import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5fa3adaa"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["src"];
const _hoisted_2 = {
  class: "title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: "img-con",
    style: _normalizeStyle({
      width: $props.width
    })
  }, [_createElementVNode("img", {
    src: $props.info.img
  }, null, 8, _hoisted_1), _createElementVNode("div", _hoisted_2, _toDisplayString($props.info.title), 1), _createElementVNode("div", {
    style: _normalizeStyle({
      height: $props.desch
    }),
    class: "desc"
  }, _toDisplayString($props.info.desc), 5)], 4);
}